import { apiHolder as api, conf as config, apis, getCspTag } from 'api';
import { safeDecodeURIComponent } from '@web-common/utils/utils';
import { handleCopyImg as _handleCopyImg } from './utils/handle-copy-img';
import { getImageFormatFromUrl as _getImageFormatFromUrl } from './utils/get-img-from-url';
import { downloadImg as _downloadImg, randomName as _randomName } from './utils/download-img';
const systemApi = api.api.getSystemApi();
const mailConfigApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const isElectron = systemApi.isElectron();
const iframeCsp = config('iframeCsp');
const contextPath = config('contextPath');
let host = config('host');
if (!isElectron) {
    host = mailConfigApi.getNewWebMailHost({ normal: true });
}
console.log('contextPathconfig', host);
const headers = `
<head>
<base target="_blank" />
<style type="text/css">
img{cursor:zoom-in;}
</style>
<style id="imgMaxWidth" type="text/css">
</style>
<style id="cloudAttachStyle" type="text/css">
</style>
<style id="ntes_link_color" type="text/css">a,td a{color:#386EE7}</style>
<style id="blockquoteStyle" type="text/css">blockquote{}</style>
<link rel="stylesheet" type="text/css" href="${host}${contextPath}/read_mail.css">
<style type="text/css">
  body{
    font-size:14px;
    font-family:arial,verdana,sans-serif;
    line-height:1.666;
  }
</style>
${getCspTag(iframeCsp)}
</head>
`;
const defaultMailCss = `
<style type="text/css">
body{
  padding:0;
  margin:0;
  overflow:auto;
  white-space:normal;
  word-wrap:break-word;
  min-height:100px;
  position:absolute;
  box-sizing: border-box;
  width:100%;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
}
html{
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
  display: block !important;
}
html::-webkit-scrollbar {
  display: none; /* WebKit browsers */
}
body::-webkit-scrollbar {
  display: none; /* WebKit browsers */
}
td, input, button, select, body{font-family:Helvetica, 'Microsoft Yahei', verdana}
pre {white-space:pre-wrap;white-space:-moz-pre-wrap;white-space:-pre-wrap;white-space:-o-pre-wrap;word-wrap:break-word;width:95%}
th,td{font-family:arial,verdana,sans-serif;}
img{ border:0}
header,footer,section,aside,article,nav,hgroup,figure,figcaption{display:block}
blockquote{margin-right:0px}
a > img {cursor:pointer !important}
</style>
`;
const mailTemplatePreviewHeaders = `
<head>
<base target="_blank" />
<style type="text/css">
img{cursor:zoom-in;}
</style>
<style id="imgMaxWidth" type="text/css">
</style>
<style id="cloudAttachStyle" type="text/css">
</style>
<style type="text/css">
body{font-size:14px;font-family:arial,verdana,sans-serif;line-height:1.666;padding:0;margin:0;overflow:auto;white-space:normal;word-wrap:break-word;min-height:100px;position:absolute;width:100%;}
td, input, button, select, body{font-family:Helvetica, 'Microsoft Yahei', verdana}
pre {white-space:pre-wrap;white-space:-moz-pre-wrap;white-space:-pre-wrap;white-space:-o-pre-wrap;word-wrap:break-word;width:95%}
th,td{font-family:arial,verdana,sans-serif;}
img{ border:0}
header,footer,section,aside,article,nav,hgroup,figure,figcaption{display:block}
blockquote{margin-right:0px}
a > img {cursor:pointer !important}
body::-webkit-scrollbar {display: none;}
</style>
<style id="ntes_link_color" type="text/css">a,td a{color:#386EE7}</style>
<style id="blockquoteStyle" type="text/css">blockquote{}</style>
<link rel="stylesheet" type="text/css" href="${host}${contextPath}/read_mail.css">
${getCspTag(iframeCsp)}
</head>
`;
const getImgBottomAlignStyle = () => {
    try {
        return mailConfigApi.canUseImgBottomAlign() ? '<style type="text/css">img{vertical-align:bottom;}</style>' : '';
    }
    catch (error) {
        return '';
    }
};
const mailContentWrapper = (content) => `
${content}
<script  type="text/javascript" src="${host}${contextPath}/read_mail_web.js"></script>
<script  type="text/javascript" src="${host}${contextPath}/read_mail_find.js"></script>
`;
const readWrapper = (mailContent) => `<!DOCTYPE html><html>${headers}${getImgBottomAlignStyle()}${mailContentWrapper(mailContent || '')}${defaultMailCss}</html>`;
export const mailTemplatePreviewWrapper = (mailContent) => `<!DOCTYPE html><html>${mailTemplatePreviewHeaders}${getImgBottomAlignStyle()}${mailContentWrapper(mailContent || '')}</html>`;
export const readWrapperNoAdjustImage = (mailContent) => `${headers}${mailContentWrapper(mailContent)}${defaultMailCss}`;
export const getImageFormatFromUrl = _getImageFormatFromUrl;
export const handleCopyImg = _handleCopyImg;
export const randomName = _randomName;
export const downloadImg = _downloadImg;
export function parseUrlParams(url) {
    const params = {};
    try {
        url = safeDecodeURIComponent(url);
        if (!url || url === '' || typeof url !== 'string') {
            return params;
        }
        const path = url.split('?')[0];
        params.path = path;
        const paramsStr = url.split('?')[1];
        if (!paramsStr) {
            return params;
        }
        const paramsArr = paramsStr.split('&');
        for (let i = 0; i < paramsArr.length; i++) {
            const key = paramsArr[i].split('=')[0];
            const value = paramsArr[i].split('=')[1];
            params[key] = value === 'true' ? true : value === 'false' ? false : value;
        }
    }
    catch (error) {
        console.error('Error parsing URL params:', error);
    }
    return params;
}
export default readWrapper;
